export const SHOW_SNACKBAR = '@snackbar/SHOW_SNACKBAR';
export const HIDE_SNACKBAR = '@snackbar/HIDE_SNACKBAR';

export const APP_LIST_WITH_PROXY = '@main/APP_LIST_WITH_PROXY';
export const SEARCH_APPLICATION = '@main/SEARCH_APPLICATION';
